<template lang="pug">
  .deviceModalWarning
    .van-cell-group__title {{ $t('new3.auth.device.title') }}

    van-cell-group.no-margin-top
      van-cell(
        :value="unitWarning")

    .popup__button.popup__button--confirm(@click="$emit('close')")
      | {{ $t('unit.confirm') }}
</template>

<script>
export default {
  props: {
    unitWarning: {
      type: String,
      required: true,
    },
  },
};
</script>
